export class FilterCurrentState {
  constructor(readonly value: string) {}
}
